export default [{
  path: '*',
  meta: {
    public: true,
  },
  redirect: {
    path: '/404'
  }
},
{
  path: '/404',
  meta: {
    public: true,
  },
  name: 'NotFound',
  component: () =>
      import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/pages/NotFound.vue`
      )
},
{
  path: '/403',
  meta: {
    public: true,
  },
  name: 'AccessDenied',
  component: () =>
      import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/pages/Deny.vue`
      )
},
{
  path: '/500',
  meta: {
    public: true,
  },
  name: 'ServerError',
  component: () =>
      import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/pages/Error.vue`
      )
},
{
  path: '/login',
  meta: {
    public: true,
  },
  name: 'Login',
  component: () =>
      import(
        `@/pages/Login.vue`
      )
},
/* Surveys routes */
{
  path: '/',
  meta: {},
  name: 'Root',
  redirect: {
    name: 'Surveys'
  }
},
{
  path: '/surveys',
  meta: {
    breadcrumb: true,
    requiresAuth: true
  },
  name: 'Surveys',
  component: () =>
    import(
      `@/components/client/surveys/List.vue`
    ),
},
{
  path: '/surveys/:survey_id/show',
  meta: {
    requiresAuth: true
  },
  name: 'SurveyShow',
  props: true,
  component: () =>
    import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/components/client/surveys/Show.vue`
    )
},
{
  path: '/rounds/:round_id/nps-dashboard',
  meta: {
    requiresAuth: true,
    breadcrumb: false
  },
  name: 'RoundNpsDashboard',
  props: true,
  component: () =>
    import(
      `@/components/client/rounds/nps-dashboard/Page.vue`
    )
},
{
  path: '/surveys/create',
  meta: {
    breadcrumb: true,
    requiresAuth: true
  },
  name: 'SurveyCreate',
  component: () =>
    import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/components/client/surveys/Create.vue`
    )
},

{
  path: '/contacts',
  meta: {
    breadcrumb: true,
    requiresAuth: true
  },
  name: 'Contacts',
  component: () =>
      import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/components/client/contacts/Page.vue`
      )
},
{
  path: '/client/devices',
  meta: {
    breadcrumb: true,
    requiresAuth: true
  },
  name: 'DevicesClients',
  component: () =>
    import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/components/client/devices/List.vue`
    )
},
{
  path: '/client/devicegroups',
  meta: {
    breadcrumb: true,
    requiresAuth: true
  },
  name: 'DevicesGroups',
  component: () =>
    import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/components/client/devicegroups/List.vue`
    )
},
{
  path: '/client/devicegroups_organization',
  meta: {
    breadcrumb: true,
    requiresAuth: true
  },
  name: 'DevicesGroupsOrganization',
  component: () =>
    import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/components/client/devicegroups/Organization.vue`
    )
},
{
  path: '/clients',
  meta: {
    breadcrumb: true,
    requiresAuth: true
  },
  name: 'Clients',
  component: () =>
    import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/components/admin/clients/List.vue`
    )
},
{
  path: '/users',
  meta: {
    breadcrumb: true,
    requiresAuth: true
  },
  name: 'Users',
  component: () =>
    import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/components/commons/users/List.vue`
    )
},
{
  path: '/devices',
  meta: {
    breadcrumb: true,
    requiresAuth: true
  },
  name: 'Devices',
  component: () =>
    import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/components/admin/devices/List.vue`
    )
},
/* Surveys public logic response */ 
{
  path: '/survey/:contact_id/:round_id/:email/:score?',
  meta: {
    survey: true,
    public: true,
  },
  name: 'Survey',
  component: () =>
    import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/surveys/App.vue`
    )
},
{
  path: '/public/survey/device/:token',
  meta: {
    survey: true,
    public: true,
  },
  name: 'SurveyDevices',
  component: () =>
    import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/surveys/SurveyDevices.vue`
    )
},
  /* v2 surveys */
{
  path: '/v2/survey/:contact_id/:round_id/:email/:score?',
  meta: {
    survey: true,
    public: true,
  },
  name: 'SurveyV2',
  component: () =>
    import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/surveys/v2/App.vue`
    )
},
{
  path: '/survey/:survey_id/:contact_id/:round_id/:question_id',
  meta: {
    survey: true,
    public: true,
  },
  name: 'SurveyQuestion',
  component: () =>
    import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/surveys/SurveyMailing.vue`
    )
},
{
  path: '/unsubscribe/:contact_id',
  meta: {
    survey: true,
    public: true,
  },
  name: 'SurveyThanks',
  component: () =>
    import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/surveys/Thanks.vue`
    )
},
{
  path: '/geolocation/:survey_id',
  meta: {
    breadcrumb: false,
    requiresAuth: true
  },
  name: 'Geolocation',
  component: () =>
      import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/components/client/map/Map.vue`
      )
},

];



// WEBPACK FOOTER //
// ./src/router/paths_eureka.js